<form #sipReasonDuplicateGroupDialog="ngForm" autocomplete="off" class="sip-groups-duplicate-dialog">
  <mat-form-field class="fullWidth">
    <mat-label>Name</mat-label>
    <input matInput required [(ngModel)]="sipReasonGroup.name" maxlength="255" name="name">
  </mat-form-field>

  <mat-form-field class="fullWidth">
    <mat-label>Description</mat-label>
    <input matInput [(ngModel)]="sipReasonGroup.description" maxlength="255" name="name">
  </mat-form-field>

  <div class="search-container">
    <client-filter (onFilter)="onFilter($event)"></client-filter>
  </div>

  <div class="sip-reason-group-table">
    <arm-table #sipReasonsTable [displayedColumns]="displayedColumns"
               [isSelectedByDefault]="false" (onSelection)="onSelection($event)"
               [data]="sipReasonGroup.sipResponseBehaviors" [isMultipleSelection]="false"
               [isClientSide]="true" [filter]="sipReasonsFilter"></arm-table>
  </div>
</form>

